var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIns2IconConnectors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0559 5.33334C20.2021 5.33334 18.6875 6.848 18.6875 8.70176C18.6875 9.14218 18.7691 9.56969 18.9244 9.95621L12.5207 13.5088C11.9225 12.9667 11.1329 12.6316 10.2664 12.6316C8.41265 12.6316 6.89798 14.1462 6.89798 16C6.89798 17.8538 8.41265 19.3684 10.2664 19.3684C11.1366 19.3684 11.9304 19.0372 12.5294 18.4912L18.9331 22.0438C18.775 22.4331 18.6875 22.8539 18.6875 23.2982C18.6875 25.152 20.2021 26.6667 22.0559 26.6667C23.9096 26.6667 25.4243 25.152 25.4243 23.2982C25.4243 21.4445 23.9096 19.9298 22.0559 19.9298C21.0465 19.9298 20.1392 20.3795 19.5209 21.0877L13.2315 17.5966C13.4889 17.1208 13.6348 16.5766 13.6348 16C13.6348 15.4209 13.4914 14.8808 13.2315 14.4037L19.5209 10.9123C20.1395 11.6213 21.0459 12.0702 22.0559 12.0702C23.9096 12.0702 25.4243 10.5555 25.4243 8.70176C25.4243 6.848 23.9096 5.33334 22.0559 5.33334Z",
    fill: "#6F7687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIns2IconConnectors);
export default __webpack_public_path__ + "static/media/ins2-icon-connectors.9594395c3e06193ad6e608762c8ddb15.svg";
export { ForwardRef as ReactComponent };